import React, { useContext } from 'react';

import PropTypes from 'prop-types';

import PaymentForm from './PaymentForm';
import { AuthContext } from '../../../../context/AuthContext';

const PaymentCard = ({ amount, bookingid, onSubmit }) => {
  const { agentId, userId } = useContext(AuthContext);
  return (
    <div>
      <PaymentForm amount={amount} bookingid={bookingid} handleAddPayment={onSubmit} />
    </div>
      
   
  );
};
PaymentCard.propTypes = {
  amount: PropTypes.string.isRequired,
  bookingid: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default PaymentCard;


